import React from 'react'
import { MenuItemList } from '../Components/Page/MenuItem'

function Home() {
  return (
    <>
     <MenuItemList/>
    </>
  )
}

export default Home